import { fetchOk } from '@atlassian/mpac-fetch-wrapper';

/* Get list of apps for a Partner */
export const getPartnerSpecificApps = (mpacBaseUrl, partnerId, queryParams) => {
  // URLSearchParams expects all params to be a string
  const stringifiedParams = {};
  Object.keys(queryParams).map(key => {
    var _queryParams$key;

    return stringifiedParams[key] = (_queryParams$key = queryParams[key]) === null || _queryParams$key === void 0 ? void 0 : _queryParams$key.toString();
  });
  const params = new URLSearchParams(stringifiedParams);
  return fetchOk("".concat(mpacBaseUrl, "/rest/2/addons/vendor/").concat(partnerId, "?").concat(params.toString())).then(response => response.json());
};